import { TradingModal } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import type { CreatePlantPayload, User } from '@/interfaces';
import type { PricingIndex } from '@/api/services/settings/pricing-indices.service';

import CompanyCupsForm from '../forms/CompanyCupsForm';

import usePlantForm from '../../hooks/utils/usePlantForm';

type Props = {
  setIsOpen: (isOpen: boolean) => void;
  companyUsers: User[];
  pricingIndices: PricingIndex[];
  handleCreatePlant: (payload: CreatePlantPayload) => Promise<void> | void;
  companyId: number;
};

export default function CreateCompanyCupsModal({
  setIsOpen,
  companyUsers,
  pricingIndices,
  handleCreatePlant,
  companyId,
}: Props) {
  const { t } = useTranslation();

  const { form, isSubmitting, errors, updateField, updateUsers, handleSubmit } = usePlantForm({
    onSubmit: async (payload) => {
      await handleCreatePlant(payload);
      setIsOpen(false);
    },
    companyId,
  });

  return (
    <TradingModal
      titleText={t('settings.companyDetailsTab.companyCups.modal.createCupsTitle')}
      bodyText={
        <CompanyCupsForm
          form={form}
          isSubmitting={isSubmitting}
          errors={errors}
          companyUsers={companyUsers}
          pricingIndices={pricingIndices}
          updateField={updateField}
          updateUsers={updateUsers}
          handleSubmit={handleSubmit}
          type="create"
        />
      }
      open
      onClose={() => setIsOpen(false)}
      styleModal={{
        minHeight: '35%',
        overflow: 'visible',
      }}
      shouldCloseOnBackdropClick={false}
    />
  );
}
